import type { ChatRoom, IUser } from 'garden-common';

export function dummyDeletedUser(): Partial<IUser<string>> & { isDeleted: true } {
  return {
    isDeleted: true,
    name: 'Deleted User',
    userName: 'Deleted User',
    email: '',
    password: '',
    userTotalEarnedSeed: 10,
    userSeedPercentChange: 10,
    userSeedChangeDifference: 10,
    userTotalItemsSold: 10,
    userTotalComments: 10,
    userTotalShares: 10,
    everyUserComment: 10,
    userComments: [],
    userTotalLikes: 10,
    userTotalReceivedLikes: 10,
    likes: [],
    followingUsers: [],
    followers: [],
    isFollowing: false,
    isFollower: false,
    isFriend: false,
    isMatchedDonator: false,
    twoFactorAuth: {
      enabled: false,
      secret: null
    },
    isPrimeAccount: false,
    drafts: [],
    followingUsersAmount: 10,
    followersAmount: 10,
    blockedUsers: [],
    userBlockedBy: [],
    userItems: [],
    totalDonatedSeed: 10,
    userTotalDonatedSeedPercentChange: 10,
    userTotalDonatedSeedDifference: 10,
    userTotalPosts: 10,
    userTotalPostsPercentChange: 10,
    userTotalPostsDifference: 10,
    userTotalDonations: 10,

    isVerified: false,
    isInterviewed: false,
    OnboardingTaskDone: true,
    emailVerified: false,
    userNotifications: [],
    followRequestsSent: [],
    followRequestsReceived: [],
    badges: [],
    isAdmin: false,

    fcmTokens: [],

    isMessagingEnabled: false,
    userTotalViews: 10,
    isViewed: false,
    views: []
  };
}

export function dummyRoomData(): ChatRoom {
  return {
    _id: null,
    creator: null,
    participants: [
      {
        isDeleted: true,
        name: 'Deleted User',
        userName: 'Deleted User',
        email: '',
        password: '',
        userTotalEarnedSeed: 10,
        userSeedPercentChange: 10,
        userSeedChangeDifference: 10,
        userTotalItemsSold: 10,
        userTotalComments: 10,
        userTotalShares: 10,
        everyUserComment: 10,
        userComments: [],
        userTotalLikes: 10,
        userTotalReceivedLikes: 10,
        likes: [],
        followingUsers: [],
        followers: [],
        isFollowing: false,
        isFollower: false,
        isFriend: false,
        isMatchedDonator: false,
        twoFactorAuth: {
          enabled: false,
          secret: null
        },
        isPrimeAccount: false,
        drafts: [],
        followingUsersAmount: 10,
        followersAmount: 10,
        blockedUsers: [],
        userBlockedBy: [],
        userItems: [],
        totalDonatedSeed: 10,
        userTotalDonatedSeedPercentChange: 10,
        userTotalDonatedSeedDifference: 10,
        userTotalPosts: 10,
        userTotalPostsPercentChange: 10,
        userTotalPostsDifference: 10,
        userTotalDonations: 10,

        isVerified: false,
        isInterviewed: false,
        OnboardingTaskDone: true,
        emailVerified: false,
        userNotifications: [],
        followRequestsSent: [],
        followRequestsReceived: [],
        badges: [],
        isAdmin: false,

        fcmTokens: [],

        isMessagingEnabled: false,
        userTotalViews: 10,
        isViewed: false,
        views: []
      }
    ],
    activeParticipants: null,
    createdAt: null,
    isLoading: null,
    updatedAt: null
  };
}
